import axiosClient from "@/libs/axiosClient";

export const getWildcardCSR = ({ groupName, servername }) => {
    return axiosClient.get(`/certs/wildcard/${servername}?groupName=${groupName}`);
};

export const regenerateWildcardCSR = (data) => {
    return axiosClient.post(`/certs/wildcard/generate-cname`, data);
};



// WEBPACK FOOTER //
// ./src/api/certs.js